import React from 'react';
import Link from 'components/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './PaginationWidget.scss';

const getPageNumbers = (totalStories, storiesPerPage, currentPage) => {
  // Calculate the total number of pages
  const totalPages = Math.ceil(totalStories / storiesPerPage);

  if (currentPage > totalPages) {
    return [];
  }

  // Determine the starting page number for the array of 5 page numbers
  let startPage = currentPage;
  const endPage = Math.min(totalPages, startPage + 4);

  // Adjust the starting page number if there are not enough pages to display
  if (endPage - startPage < 4) {
    startPage = Math.max(1, endPage - 4);
  }

  // Store the 5 page numbers in an array
  // const pageNumbers = [];
  // for (let i = startPage; i <= endPage; i += 1) {
  //   pageNumbers.push(i);
  // }
  const pageNumbers = Array.from(
    { length: Math.min(5, totalPages) },
    (_, index) => startPage + index,
  );

  return pageNumbers;
};

const PaginationWidget = props => {
  const {
    currentPage = 1,
    totalStories,
    storiesPerPage,
    location,
    isMobile,
  } = props;
  if (!(totalStories && storiesPerPage && location)) {
    return null;
  }

  let linkLocation;
  if (typeof location === 'object' && location.pathname) {
    linkLocation = location.pathname;
  } else if (typeof location === 'string' && location.length > 0) {
    linkLocation = location;
  }

  if (
    linkLocation.length > 0 &&
    linkLocation.charAt(linkLocation.length - 1) === '/'
  ) {
    linkLocation = linkLocation.substr(0, linkLocation.length - 1);
  }

  const totalPages = Math.ceil(totalStories / storiesPerPage);
  const pages = getPageNumbers(totalStories, storiesPerPage, currentPage);

  if (!(Array.isArray(pages) && pages.length && pages.length > 0)) {
    return null;
  }

  const sendGAOnPageClick = (category, clickedPage) => {
    if (clickedPage) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'listing_pagination',
        category,
        label: typeof window === 'object' ? window?.location?.href : location,
        page_no: clickedPage,
      });
    }
  };

  return (
    <div className={`${isMobile ? s.mobileWrapper : ''} ${s.paginationWrap}`}>
      <Link
        to={`${linkLocation}/${currentPage - 1}`}
        className={`${s.arrowBtn}  ${!(currentPage > 1) ? s.disabled : ''} ${
          s.prevButton
        }`}
        onClick={() => {
          sendGAOnPageClick(
            'previous_page',
            `${linkLocation}/${currentPage - 1}`,
          );
        }}
      />

      <ul>
        {pages.map(page => (
          <li>
            <Link
              className={page === currentPage ? s.selected : ''}
              to={`${linkLocation}/${page}`}
              onClick={() => {
                sendGAOnPageClick('page_index', `${linkLocation}/${page}`);
              }}
            >
              {page}
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to={`${linkLocation}/${currentPage + 1}`}
        className={`${s.arrowBtn} ${s.nextButton} ${
          !(currentPage + 1 <= totalPages) ? s.disabled : ''
        }`}
        onClick={() => {
          sendGAOnPageClick('next_page', `${linkLocation}/${currentPage + 1}`);
        }}
      />
    </div>
  );
};

export default PaginationWidget;
